import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ConfigProvider, Spin, theme } from 'antd';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout from './components/AppLayout';
import SurveyList from './pages/SurveyList';
import TakeSurvey from './pages/TakeSurvey';
import SurveyResults from './pages/SurveyResults';
import CreateSurvey from './pages/CreateSurvey';
import CityStats from './pages/CityStats';
import Login from './pages/Login';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { token, isLoading } = useAuth();
  if (isLoading)
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}><Spin size="large" /></div>;
  if (!token) return <Navigate to="/login" replace />;
  return <AppLayout>{children}</AppLayout>;
}

export default function App() {
  return (
    <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm, token: { colorPrimary: '#fa8c16' } }}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute><SurveyList /></ProtectedRoute>} />
            <Route path="/take/:id" element={<ProtectedRoute><TakeSurvey /></ProtectedRoute>} />
            <Route path="/results/:id" element={<ProtectedRoute><SurveyResults /></ProtectedRoute>} />
            <Route path="/create" element={<ProtectedRoute><CreateSurvey /></ProtectedRoute>} />
            <Route path="/stats" element={<ProtectedRoute><CityStats /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </ConfigProvider>
  );
}
